import { create } from 'zustand';
import type { KBChatSource } from '@/services/api/knowledge-base';

export interface KBMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  sources?: KBChatSource[];
  answerable?: boolean;
  timestamp: number;
}

interface KBStore {
  isOpen: boolean;
  activeTab: 'articles' | 'chat';
  messages: KBMessage[];
  toggleOpen: () => void;
  setOpen: (open: boolean) => void;
  setActiveTab: (tab: 'articles' | 'chat') => void;
  addMessage: (message: Omit<KBMessage, 'id' | 'timestamp'>) => void;
  clearMessages: () => void;
}

let messageCounter = 0;

export const useKBStore = create<KBStore>()((set) => ({
  isOpen: false,
  activeTab: 'articles',
  messages: [],
  toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (open) => set({ isOpen: open }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  addMessage: (message) =>
    set((state) => ({
      messages: [
        ...state.messages,
        {
          ...message,
          id: `msg-${++messageCounter}`,
          timestamp: Date.now(),
        },
      ],
    })),
  clearMessages: () => set({ messages: [] }),
}));
